<template>
  <div class="sync-data-list">
    <div class="d-flex justify-content-between align-items-center sync-data-list__header">
      <div>
        <div class="sync-data-list__title fw-bold">Danh sách tài khoản Contact</div>
        <div class="sync-data-list__description">
          Đồng bộ liên hệ mới từ Salework Zalo sang Salework Contact.
        </div>
      </div>
      <div class="sync-data-list__actions">
        <el-input
          v-model="searchKey"
          clearable
          size="small"
          prefix-icon="el-icon-search"
          placeholder="Tìm theo tên, biệt danh hoặc số điện thoại"
          class="sync-data-list__search" />
        <el-button type="primary" size="small" @click="saveSetting">
          Lưu và đồng bộ
        </el-button>
      </div>
    </div>

    <el-table
      :data="viewAccount"
      row-key="accountId"
      border
      size="small"
      class="sync-data-table"
      empty-text="Không có dữ liệu">
      <el-table-column label="Tài khoản" min-width="220">
        <template slot-scope="scope">
          <div class="sync-account-cell">
            <el-avatar :src="scope.row.avatar" :size="32"></el-avatar>
            <div class="sync-account-info">
              <div class="sync-account-name">{{ scope.row.displayName }}</div>
              <div v-if="scope.row.swName" class="sync-account-alias">
                Biệt danh: {{ scope.row.swName }}
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Bộ lọc" width="110" align="center">
        <template slot-scope="scope">
          <el-button size="small" @click="handleFilterSync(scope.row)">
            Bộ lọc
          </el-button>
        </template>
      </el-table-column>
      <el-table-column label="Kho dữ liệu" min-width="180">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.storageId"
            size="small"
            placeholder="Chọn kho"
            class="w-100">
            <el-option v-for="str in storages" :key="str.id" :value="str.id" :label="str.name" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="Quy trình" min-width="220">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.processIds"
            size="small"
            placeholder="Chọn quy trình"
            multiple
            collapse-tags
            clearable
            class="w-100">
            <el-option v-for="p in processes" :key="p.id" :value="p.id" :label="p.name" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="Kích hoạt" width="120" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.active" @change="handleAccountToggle(scope.row)" />
        </template>
      </el-table-column>
    </el-table>

    <DialogFilterSync
      v-if="dialogFilterSync"
      :config="selectedAccount.config"
      @close="handleCloseDialogFilterSync"
      @saveFilter="saveFilter" />
  </div>
</template>

<script>
import DialogFilterSync from "./DialogFilterSync.vue";

export default {
  name: "SwContactSetting",
  components: { DialogFilterSync },
  data() {
    return {
      searchKey: "",
      accounts: [],
      storages: [],
      processes: [],
      checkAll: false,
      dialogFilterSync: false,
      selectedAccount: {}
    };
  },
  computed: {
    viewAccount() {
      const keyword = this.normalizeSearchText(this.searchKey);
      const phoneKeyword = this.normalizePhoneText(this.searchKey);
      if (!keyword) return this.accounts;

      return this.accounts.filter(account => {
        return [
          account.displayName,
          account.swName,
          account.phoneNumber,
          account.phone
        ].some(value => {
          const normalizedValue = this.normalizeSearchText(value);
          const normalizedPhone = this.normalizePhoneText(value);
          return normalizedValue.includes(keyword)
            || (phoneKeyword && normalizedPhone.includes(phoneKeyword));
        });
      });
    }
  },
  methods: {
    handleFilterSync(account) {
      this.dialogFilterSync = true;
      this.selectedAccount = account;
    },
    handleCloseDialogFilterSync() {
      this.dialogFilterSync = false;
    },
    saveFilter(data) {
      if (!this.selectedAccount) return;

      this.selectedAccount.config = JSON.stringify(data);

      const index = this.accounts.findIndex(acc => acc.accountId === this.selectedAccount.accountId);
      if (index !== -1) {
        this.$set(this.accounts, index, { ...this.selectedAccount });
      }

      this.dialogFilterSync = false;
    },
    async saveSetting() {
      window.open("https://contact.salework.net", "_blank");
      this.$message.success("Vui lòng chờ trong giây lát");
      await new Promise(resolve => setTimeout(resolve, 5000));
      const payload = this.accounts.map(acc => ({
        ...acc,
        processIds: JSON.stringify(acc.processIds || [])
      }));
      const res = await this.$http.post("/api/sw-contact/save", payload);
      if (res.error) {
        this.alertError("error", res.error.message);
        return;
      }
      this.$message.success("Lưu cài đặt thành công");
    },
    getAll() {
      this.accounts = [];
      this.$http.get("/api/sw-contact/setting").then((res => {
        let existingAccountIds = new Set();

        if (res.data) {
          res.data.forEach((a) => {
            let acc = this.app.accounts.find((f) => f.accountId == a.accountId);
            if (acc) {
              a.accountId = acc.accountId;
              a.displayName = acc.displayName;
              a.swName = acc.swName;
              a.avatar = acc.avatar;
              a.phoneNumber = acc.phoneNumber;
              a.phone = acc.phone;
              a.storageId = a.storageId || this.storages[0]?.id;
              if (typeof a.processIds === "string") {
                try { a.processIds = JSON.parse(a.processIds); } catch (e) { a.processIds = []; }
              }
              if (!Array.isArray(a.processIds)) a.processIds = [];
              if (!a.config) {
                a.config = JSON.stringify({
                  onlyPhone: false,
                  tags: []
                });
              }
              this.accounts.push(a);
              existingAccountIds.add(a.accountId);
            }
          });
        }

        this.app.accounts.forEach((acc) => {
          if (!existingAccountIds.has(acc.accountId)) {
            const config = {
              onlyPhone: false,
              tags: []
            };
            this.accounts.push({
              accountId: acc.accountId,
              displayName: acc.displayName,
              swName: acc.swName,
              avatar: acc.avatar,
              phoneNumber: acc.phoneNumber,
              phone: acc.phone,
              storageId: this.storages[0]?.id,
              processIds: [],
              config: JSON.stringify(config)
            });
          }
        });

        this.updateCheckAllStatus();
      })
      );
    },
    async getAllStorage() {
      const res = await this.$http.get("/api/sw-contact/storages");
      if (res.error) {
        this.$message.error(res.error.message);
        return;
      }
      this.storages = res.data.data;
    },
    async getAllProcess() {
      const res = await this.$http.get("/api/sw-contact/processes");
      if (res.error) {
        this.$message.error(res.error.message);
        return;
      }
      this.processes = res.data.data;
    },
    normalizeSearchText(value) {
      return (value || "")
        .toString()
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/đ/g, "d");
    },
    normalizePhoneText(value) {
      const phone = (value || "").toString().replace(/\D/g, "");
      if (phone.startsWith("840")) return "0" + phone.substring(3);
      if (phone.startsWith("84")) return "0" + phone.substring(2);
      return phone;
    },
    toggleAllAccounts() {
      const newState = this.checkAll;
      this.viewAccount.forEach((account) => {
        account.active = newState;
      });
    },
    handleAccountToggle() {
      this.updateCheckAllStatus();
    },
    updateCheckAllStatus() {
      this.checkAll = this.accounts.length > 0 && this.accounts.every((account) => account.active);
    },
    syncImediately(accountId) {
      let payload = {
        accountIds: [accountId]
      };
      this.$http.post("/api/sw-contact/sync-imediately", payload).then((res) => {
        if (res.error) {
          this.$message.error(res.error.message);
          return;
        }
        this.$message.success("Đồng bộ thành công");
      }).catch(() => {
        this.$message.error("Đồng bộ thất bại.");
      });
    }
  },
  async created() {
    await Promise.all([this.getAllStorage(), this.getAllProcess()]);
    this.getAll();
  }
};
</script>

<style scoped>
.sync-data-list {
  background: #ffffff;
  border: 1px solid #dcdfe9;
  border-radius: 8px;
  padding: 12px;
}

.sync-data-list__title {
  color: #202125;
  font-size: 16px;
}

.sync-data-list__description {
  color: #696b72;
  font-size: 14px;
  margin-top: 4px;
}

.sync-data-list__header {
  gap: 12px;
  margin-bottom: 12px;
}

.sync-data-list__actions {
  align-items: center;
  display: flex;
  flex: 1;
  gap: 8px;
  justify-content: flex-end;
  min-width: 0;
}

.sync-data-list__search {
  max-width: 360px;
}

::v-deep .sync-data-table {
  font-size: 14px;
}

::v-deep .sync-data-table th {
  color: #696b72;
  font-size: 14px;
  font-weight: 700;
}

.sync-account-cell {
  align-items: center;
  display: flex;
  gap: 10px;
  min-width: 0;
}

.sync-account-info {
  min-width: 0;
}

.sync-account-name {
  color: #202125;
  font-size: 14px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sync-account-alias {
  color: #d93025;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .sync-data-list__header,
  .sync-data-list__actions {
    align-items: stretch !important;
    flex-direction: column;
  }

  .sync-data-list__search {
    max-width: none;
  }
}
</style>
